import { render, staticRenderFns } from "./StockAdjustmentItems.vue?vue&type=template&id=c20ff296"
import script from "./StockAdjustmentItems.vue?vue&type=script&lang=js"
export * from "./StockAdjustmentItems.vue?vue&type=script&lang=js"
import style0 from "./StockAdjustmentItems.vue?vue&type=style&index=0&id=c20ff296&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports